<template>
    <loading :active="isLoading" :is-full-page="true">
    </loading>
    <div v-if="isMobile" class="d-flex flex-column">
        <div v-for="cell in cells" :key="cell.id" class="my-1">
            <table-cell class="h-100" :name="cell.name" :model-value="getValue(cell.id)"
                        :bg-color="cell.color_hex" :hint="cell.hint" :rowcount='cell.height'
                        :max-height="rowMaxHeights[index]"
                        @update:model-value="setValue({value:$event, id:cell.id})"
                        @update:height="updateHeight({value:$event, id:cell.id, cell:cell})"
            ></table-cell>
        </div>
    </div>
    <table class="table table-borderless template-table" v-else>
        <tbody>
        <tr v-for="(row, index) in rows" :key="index">
            <td v-for="cell in row" :key="cell.id" :rowspan="cell.height" :colspan="cell.width" :width="colWidth">
                <table-cell class="h-100" :name="cell.name" :model-value="getValue(cell.id)"
                            :bg-color="cell.color_hex" :hint="cell.hint" :rowcount='cell.height'
                            :max-height="rowMaxHeights[index]"
                            @update:model-value="setValue({value:$event, id:cell.id})"
                            @update:height="updateHeight({value:$event, id:cell.id, cell:cell})"
                ></table-cell>
            </td>
        </tr>
        </tbody>
    </table>
    <button class="btn btn-primary save-btn" @click="saveValues">Сохранить</button>
    <div class="modal-form" v-show="isRegister">
        <div class="modal-form-content">
            <UserLogin @close-modal="isRegister=false" v-bind:key="userLoginKey"
                       initial-operation="registration"></UserLogin>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import TableCell from "@/components/TableCell";
    import Loading from 'vue3-loading-overlay';
    import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
    import UserLogin from "@/components/UserLogin";

    export default {
        name: 'CardsGroup',
        props: {},
        components: {
            TableCell,
            Loading,
            UserLogin,
        },
        data: function () {
            return {
                isRegister: false,
                isModalShowResult: false,
                isLoading: false,
                cellsHeaderHeight: [],
                userLoginKey: 0,
                isMobile: false
            }
        },
        mounted() {
            const mediaQuery = window.matchMedia('(max-width: 700px)');
            this.isMobile = mediaQuery.matches;
            mediaQuery.addEventListener('change', (event) => {
                this.isMobile = event.matches;
            });
        },
        computed: {
            ...mapState({
                template: state => state.template,
                values: state => state.values,
                token: state => state.token
            }),
            ...mapGetters([
                'getValue',
                'isAuthenticated'
            ]),
            rows: function () {
                if (this.template != null) {
                    return this.template.cells.reduce((group, cell) => {
                        let {row} = cell
                        group[row] = group[row] ?? []
                        group[row].push(cell)
                        return group
                    }, {})
                }
                return []
            },
            cols: function () {
                if (this.template != null) {
                    return this.template.cells.reduce((group, cell) => {
                        let {column} = cell
                        group[column] = group[column] ?? []
                        group[column].push(cell)
                        return group
                    }, {})
                }
                return []
            },
            cells: function () {
                if (this.template != null) {
                    return this.template.cells
                }
                return []
            },
            rowMaxHeights: function () {
                let maxHeights = []
                for (let i = 0; i < this.cellsHeaderHeight.length; i++) {
                    if (i in this.cellsHeaderHeight) {
                        let rowMaxHeight = this.cellsHeaderHeight[i].reduce((maxVal, val) => Math.max(val, maxVal), 0)
                        maxHeights.push(rowMaxHeight)
                    } else {
                        maxHeights.push(0)
                    }
                }
                return maxHeights
            },
            colWidth: function () {
                if (this.cols && Object.keys(this.cols).length > 0) {
                    return Math.floor(100 / Object.keys(this.cols).length) + '%'
                }
                return '100%'
            }

        },
        methods: {
            ...mapMutations([
                'setValue'
            ]),
            ...mapActions([
                'saveCurrentTemplateValues',
                'register'
            ]),
            saveValues() {
                if (!this.isAuthenticated) {
                    this.userLoginKey++
                    this.isRegister = true
                } else {
                    this.isLoading = true
                    this.saveCurrentTemplateValues().then(
                        () => {
                            this.isLoading = false;
                        })
                }
            },
            async onRegister(values, actions) {
                if (this.validateEmail(values["email"])) {
                    let res = await this.register(values["email"])
                    if (res['is_error']) {
                        actions.setFieldError("email", res["message"]);
                    } else {
                        this.saveCurrentTemplateValues().then(
                            () => {
                                this.isLoading = false;
                            })
                        actions.resetForm()
                        this.isModalShowResult = true
                    }
                }
            },
            updateHeight(value) {
                if (!(value.cell.row in this.cellsHeaderHeight)) {
                    this.cellsHeaderHeight[value.cell.row] = []
                }
                this.cellsHeaderHeight[value.cell.row][value.cell.column] = value.value
            },
            CloseRegister() {
                this.isRegister = false
                this.isModalShowResult = false;
            },
            validateEmail(value) {
                if (!value) {
                    return 'Поле необходимо заполнить';
                }

                // if the field is not a valid email
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                if (!regex.test(value)) {
                    return 'Неправильный формат';
                }
                return true
            },
            getCurrentUrl() {
                return window.location.origin + window.location.pathname + '#/?user=' + this.token
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .template-table td {
        height: 150px;
        padding: 1px;
    }
</style>
